/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_StyleInputs */



/**
* | output |
* | --- |
* | "Style" |
*
* @param {Editor_Table_Column_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_style = /** @type {((inputs?: Editor_Table_Column_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilo")
	return /** @type {LocalizedString} */ ("Style")
});